import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgThumbUpDefault = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("circle", {
			cx: 16,
			cy: 16,
			r: 15,
			stroke: "#005AA0",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M8.00879 11.0312V23.0161H9.99121V11.0312H8.00879Z",
			fill: "#005AA0"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.1011 6.57241C17.2539 5.32463 19.3006 6.49391 18.8112 8.12066L17.9944 11.0312H21.6805C22.4294 11.0312 23.1255 11.4171 23.5225 12.0521C24.0316 12.8668 24.1324 13.8721 23.7951 14.7716L21.9678 20.418C21.3819 21.9805 19.8893 23.0161 18.2199 23.0161H14.4081C13.0805 23.0161 12.0068 21.9398 12.0068 20.6137V12.1453C12.0068 11.7425 12.1587 11.3544 12.432 11.0585L16.1011 6.57241Z",
			fill: "#005AA0"
		})
	]
});
const ForwardRef = forwardRef(SvgThumbUpDefault);
export { ForwardRef as ReactComponent };
